import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API } from "../lib/api";

export function CoachPick() {
  const [pick, setPick] = useState(null);

  useEffect(() => {
    api.get("/coach-pick")
      .then((r) => setPick(r.data))
      .catch((e) => console.error("Coach pick load failed:", e));
  }, []);

  if (!pick?.video) return null;
  const v = pick.video;

  return (
    <section data-testid="coach-pick-section" className="relative bg-[#08100D] border-y border-white/5 py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 items-center">
        <Link to={`/video/${v.video_id}`} data-testid="coach-pick-video"
              className="block relative aspect-video bg-black border border-[#C9A227]/40 overflow-hidden group">
          <video src={`${API}/videos/${v.video_id}/file`} muted playsInline preload="metadata"
                 className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition" />
          <div className="absolute top-3 left-3 overline px-2 py-1 bg-[#C9A227] text-[#050A08] font-bold">★ Coach Pick</div>
        </Link>
        <div>
          <span className="overline">Coach Pick of the Week</span>
          <h2 className="font-display text-4xl sm:text-5xl mt-4 leading-[1]" data-testid="coach-pick-title">{v.title}</h2>
          <div className="text-white/50 text-sm mt-2">by {v.author_name}</div>
          {pick.coach_note ? (
            <blockquote className="mt-6 border-l-2 border-[#C9A227] pl-5 text-white/80 italic" data-testid="coach-pick-note">
              “{pick.coach_note}”
            </blockquote>
          ) : (
            v.description && <p className="mt-6 text-white/60 max-w-xl">{v.description}</p>
          )}
          <Link to={`/video/${v.video_id}`} className="btn-primary mt-8 inline-block" data-testid="coach-pick-cta">
            Watch the Cut
          </Link>
        </div>
      </div>
    </section>
  );
}
